define('features/compare/compare.config.chrome',[
  'lib/util/langFromUrl',
], function (
  langFromUrl
) {
  function __isSpanish() {
    if ('es' === langFromUrl()) {
      return true;
    }
    return false;
  }

  return {
    isSpanish: __isSpanish(),
    buildSummaryRow: function (headings, competitorIdx) {
      var self = this;
      var vehicleMpgCombined;
      var summary = headings.find(function (obj) {
        if (self.isSpanish) {
          return obj.headingName === 'Resumen';
        }
        return obj.headingName === 'Summary';
      });

      var vehicleMsrps = summary.rowAndSubHeading.find(function (obj) {
        if (self.isSpanish) {
          return obj.rowLabel === 'MSRP Incluyendo cargo de entrega';
        }
        return obj.rowLabel === 'MSRP Including Destination Charge';
      });

      // City MPG, primary and competitor
      var vehicleMpgCity = summary.rowAndSubHeading.find(function (obj) {
        if (self.isSpanish) {
          return obj.rowLabel === 'Economía de combustible (ciudad)';
        }
        return obj.rowLabel === 'Fuel Economy (city)';
      });

      // Highway MPG, primary and competitor
      var vehicleMpgHwy = summary.rowAndSubHeading.find(function (obj) {
        if (self.isSpanish) {
          return obj.rowLabel === 'Economía de combustible (carretera)';
        }
        return obj.rowLabel === 'Fuel Economy (highway)';
      });

      // no city means it's an EV.
      if (!vehicleMpgCity) {
        var vehicleMpgCombinedHeading = headings.find(function (obj) {
          if (self.isSpanish) {
            return obj.headingName === 'Economia de Combustible';
          }
          return obj.headingName === 'Fuel Economy';
        });

        vehicleMpgCombined = vehicleMpgCombinedHeading.rowAndSubHeading.find(function (obj) {
          if (self.isSpanish) {
            return obj.rowLabel === 'Economía de combustible combinada (ciudad / carretera)';
          }
          return obj.rowLabel === 'Combined Fuel Economy (City/Hwy)';
        });
      }

      return {
        toyotaValMsrp: vehicleMsrps.vehicleData[0].colData,
        toyotaValMpg: vehicleMpgCity ? vehicleMpgCity.vehicleData[0].colData + '/' + vehicleMpgHwy.vehicleData[0].colData : vehicleMpgCombined.vehicleData[0].colData,
        rowLabel: 'MSRP & MPG',
        compValMsrp: vehicleMsrps.vehicleData[competitorIdx].colData,
        compValMpg: vehicleMpgCity ? vehicleMpgCity.vehicleData[competitorIdx].colData + '/' + vehicleMpgHwy.vehicleData[competitorIdx].colData : vehicleMpgCombined.vehicleData[competitorIdx].colData,
        rowClass: 'cv-highlight'
      };
    },
    rowsToShow: 6,
    catPrioritesObjEn: {
      'MSRP Including Delivery Charge': 1,
      'EPA City (MPG)': 2,
      'EPA Highway (MPG)': 3,
      'Combined Fuel Economy (City/Hwy)':	4,
      'Basic Warranty Months': 5,
      'Basic Warranty Miles':	6,
      'Horsepower': 7,
      'PowerTrain Warranty Months': 8,
      'PowerTrain Warranty Miles': 9,
      'Navigational System': 10,
      'Cargo Volume (cu. Ft.)': 11,
      'Maximum Towing Capacity (Lbs)': 12,
      'Smart Key System':	13,
      'Backup Camera': 14,
      'Power Sunroof/Moonroof': 15,
      'Bluetooth Hands Free Telephone Access': 16,
      'Driver Multi-Adjustable Power Seat': 17,
      'Steering Wheel Audio Controls': 18,
      'Voice Activated Controls':	19,
      'Torque': 20,
      'Brake System (front)':	21,
      'Brake System (rear)': 22,
      'Seating Capacity':	23,
      'Wheels': 24,
      'Auxiliary Input Jack':	25,
      'Satellite Radio': 26,
      'NHTSA Front Crash Test Rating - Driver': 27,
      'NHTSA Front Crash Test Rating - Passenger': 28,
      'Side Airbags':	29,
      'Front Knee Airbags': 30,
      'Front Side Airbags': 31,
      'Keyless Entry': 32,
      'Heated Exterior Mirror': 33,
      'Electronic Traction Control': 34,
      'Leg Room Front (In)': 35,
      'Leg Room Rear (In)': 36,
      'Steering Wheel Mounted Controls':	37,
      'Interior Volume (cu. ft.)':	38,
      'Roll-Sensing Side Curtain Airbags':	39,
      'Multi-function Remote':	40,
      'Low Tire Pressure Indicator':	41,
      'Side Head Curtain Airbag':	42,
      'Emissions Rating':	43,
      'Front Airbags':	44,
      'Power Mirrors':	45,
      'Leather Steering Wheel':	46,
      'On-Board Computer':	47,
      'Doors':	48,
      'Cylinders':	49,
      'Headroom Front (In)':	50,
      'Number of Cylinders':	51,
      'Headroom Rear (In)':	52,
      'Halogen Headlights':	53,
      'Anti-Corrosion Warranty Months':	54,
      'Anti-Corrosion Warranty Miles':	55,
      'Brake Assist System':	56,
      'Child Safety Door Locks':	57,
      'Interior Day/Night Electrochromic Rearview Mirror':	58,
      'Front Suspension':	59,
      'Rear Suspension':	60,
      'Vehicle Speed Proportional Power Steering':	61,
      'MP3 Player':	62,
      'One-Touch Passenger Power Window':	63,
      'Rear Split Folding Bench Seat':	64,
      'One-Touch Driver Power Window':	65,
      'Universal Garage Door Opener':	66,
      'Illuminated Vanity Mirrors':	67,
      'Number of Speakers':	68,
      'Automatic Headlights':	69,
      'Hip Room Front (In)':	70,
      'Hip Room Rear (In)':	71,
      'Wheel Diameter':	72,
      'Wheelbase (In)':	73,
      'Anti-Theft Protection':	74,
      'Compass':	75,
      'Power Door Locks':	76,
      'Power Windows':	77,
      'Front Adjustable Seat Height':	78,
      'Intermittent Wipers':	79,
      'Load Restraints':	80,
      'Number of Transmission Speeds':	81,
      'Outside Temperature Gauge':	82,
      'Curb Weight (Lbs) Automatic Transmission':	83,
      'Steering Wheel Tilt Adjustment':	84,
      'Transmission Speeds':	85,
      'Transmission Type':	86,
      'Stability Control':	87,
      'Rear Spoiler':	88,
      'Automatic Locking Retractor':	89,
      '4 Wheel ABS Brakes':	90,
      'Remote Fuel Filler Door Release':	91,
      'Cruise Control':	92,
      'Cruising Range':	93,
      'Delayed Power Retention System':	94,
      'Engine Displacement':	95,
      'Front Track (In)':	96,
      'Immobilizer':	97,
      'Climate Control':	98,
      'Fuel Capacity (Gal.)':	99,
      'Axle Ratio':	100,
      'Cargo Area Light':	101,
      'Driveline':	102,
      'Rear Track (In)':	103,
      'Rear Window Defogger':	104,
      'Remote Trunk/Hatch Release':	105,
      'Stabilizer Bar':	106,
      'Standard Transmission':	107,
      'Steering Wheel Telescopic Adjustment':	108,
      'Tachometer':	109,
      'Variable Valve Timing':	110,
      'Reading Lights':	111,
      'Pre-Tensioners':	112,
      'Passenger Air Bag Cutoff':	113,
      'Overhead Console Storage':	114,
      'Front Seat Belt Height Adjuster':	115,
      'Bore X Stroke':	116,
      'Antenna Type':	117,
      'CD Player':	118,
      'Audio System':	119,
      'Door Mounted Storage':	120,
      'Console Storage':	121,
      'Cabin Air Filter':	122,
      'Body Style':	123,
      'Tires':	124,
      'Number of Valves':	125,
      'Overall Height (In)':	126,
      'Overall Length (In)':	127,
      'Overall Width (In)':	128,
      'Seatback Storage':	129,
      'Shoulder Room Front (In)':	130,
      'Shoulder Room Rear (In)':	131,
      'Side Guard Door Beams':	132
    },
    catPrioritesObjEs: {
      'MSRP Incluyendo costo de entrega': 1,
      'Estimado EPA en ciudad (MPG)': 2,
      'Estimado EPA en carretera (MPG)': 3,
      'Economía de combustible combinada': 4,
      'Meses de garantía básica': 5,
      'Millas de garantía básica': 6,
      'Caballos de fuerza': 7,
      'Meses de garantía del tren de potencia': 8,
      'Millas de garantía del tren de potencia': 9,
      'Sistema de navegación': 10,
      'Volumen de carga (pies cú.)': 11,
      'Capacidad máxima de remolque (lbs.)': 12,
      'Sistema de llave inteligente': 13,
      'Cámara retrovisora ': 14, // space exists in service
      'Techo corredizo/parasol eléctrico ': 15, // space exists in service
      'Acceso telefónico manos libres Bluetooth® ': 16, // space exists in service
      'Asiento eléctrico del conductor ajustable en varias posiciones': 17,
      'Controles de audio en el volante': 18,
      'Controles activados por la voz': 19,
      'Torsión': 20,
      'Sistema de Frenos (delantero)': 21,
      'Sistema de Frenos (trasero)': 22,
      'Capacidad de asientos': 23,
      'Ruedas': 24,
      'Conexión auxiliar de audio': 25,
      'Radio satelital': 26,
      'NHTSA calificación de prueba de choque frontal - conductor': 27,
      'NHTSA calificación de prueba de choque frontal - acompañante': 28,
      'Bolsas de ire laterales': 29,
      'Bolsas de aire delanteras para las rodillas': 30,
      'Bolsas de aire laterales delanteras': 31,
      'Sistema de entrada sin llave': 32,
      'Espejo exterior con calefacción': 33,
      'Control Electrónico de la Tracción del Vehículo': 34,
      'Espacio para las piernas adelante (plg.)': 35,
      'Espacio para las piernas atrás (in.)': 36,
      'Controles montados en el volante': 37,
      'Volumen interior (pies cú.)': 38,
      'Bolsas de aire laterales tipo cortina con sensor de vuelco ': 39, // space exists in service
      'Control remoto multifunción': 40,
      'Indicador de la Presión Baja de los Neumáticos ': 41,
      'Bolsas de aire tipo cortina en cabecera': 42,
      'Índice de emisiones': 43,
      'Bolsas de aire delanteras': 44,
      'Espejos eléctricos': 45,
      'Volante tapizado en piel': 46,
      'Computadora a bordo': 47,
      'Puertas': 48,
      'Cilindros': 49,
      'Espacio para la cabeza adelante (plg.) ': 50, // space exists in service
      'Número de cilindros': 51,
      'Espacio para la cabeza atrás (plg.)': 52,
      'Faros delanteros de halógeno': 53,
      'Meses de garantía de anticorrosión': 54,
      'Millas de garantía de anticorrosión': 55,
      'Sistema de Asistencia de Frenado': 56,
      'Seguros para niños en las puertas': 57,
      'Espejo retrovisor interior electrocrómico de día/noche': 58,
      'Suspensión delantera': 59,
      'Suspensión trasera': 60,
      'Dirección asistida eléctricamente proporcional a la velocidad del vehículo': 61,
      'Reproductor de MP3': 62,
      'Ventana eléctricade un solo toque para el acompañante': 63,
      'Asiento trasero tipo banca con plegable dividido': 64,
      'Ventana eléctrica de un solo toque para el conductor': 65,
      'Control universal para abrir garaje': 66,
      'Espejos de visera iluminados': 67,
      'Número de bocinas': 68,
      'Faros delanteros automáticos': 69,
      'Espacio para las caderas adelante (plg.)': 70,
      'Espacio para las caderas atrás (plg.)': 71,
      'Diámetro de la rueda': 72,
      'Distancia entre ejes (plg.)': 73,
      'Protección antirrobo': 74,
      'Brújula': 75,
      'Seguros eléctricos en las puertas': 76,
      'Ventanas eléctricas': 77,
      'Asiento delantero con altura ajustable': 78,
      'Limpiaparabrisas intermitentes': 79,
      'Restricciones de carga': 80,
      'Número de velocidades ': 81, // space exists in service
      'Indicador de temperatura exterior': 82,
      'Peso en vacío (lbs.) transmisión automática': 83,
      'Volante de acercamiento ajustable': 84,
      'Velocidades de transmisión': 85,
      'Tipo de transmisión': 86,
      'Control de estabilidad': 87,
      'Alerón trasero': 88,
      'Retractor de bloque automático': 89,
      'Frenos Antibloqueo (ABS) en las 4 ruedas': 90,
      'Apertura remota de la toma de combustible ': 91, // space exists in service
      'Control automático de la velocidad': 92,
      'Rango de viaje': 93,
      'Sistema de retención retardante de electricidad': 94,
      'Desplazamiento del motor': 95,
      'Rodada delantera': 96,
      'Inmovilizador': 97,
      'Control del clima': 98,
      'Capacidad del tanque combustible (Gal.)': 99,
      'Relación de eje': 100,
      'Luz para el área de carga': 101,
      'Sistema propulsor': 102,
      'Rodada posterior (plg.)': 103,
      'Desempañador la ventana posterior ': 104, // space exists in service
      'Apertura remota del baúl/puerta posterior': 105,
      'Barra estabilizadora': 106,
      'Transmisión estándar': 107,
      'Volante de altura ajustable': 108,
      'Tacómetro': 109,
      'Sincronización Variable de Válvulas ': 110, // space exists in service
      'Luces para leer': 111,
      'Pretensores': 112,
      'Interruptor de la bolsa de aire del acompañante': 113,
      'Consola superior de almacenamiento': 114,
      'Cinturón de seguridad delantero de altura ajustable': 115,
      'Calibre del cilindro X carretera': 116,
      'Tipo de antena': 117,
      'Reproductor de CD': 118,
      'Sistema de audio': 119,
      'Almacenamiento en las puertas': 120,
      'Almacenamiento en la consola': 121,
      'Filtro de aire para la cabina': 122,
      'Tipo de carrocería': 123,
      'Neumáticos': 124,
      'Número de válvulas': 125,
      'Altura total (Plg.)': 126,
      'Largo total (Plg.)': 127,
      'Ancho total (Plg.)': 128,
      'Almacenamiento en el respaldo ': 129, // space exists in service
      'Espacio para los hombros adelante (plg.)': 130,
      'Espacio para los hombros atrás (plg.)': 131,
      'Barras protectoras laterales en las puertas': 132
    },

    footerCtx: function () {
      if (this.isSpanish) {
        return {
          txt: 'Toyota lleva ventaja',
          credit: 'Análisis independiente realizado por <a target="_blank" href="http://www.chromedata.com"><img alt="chrome data logo" src="/assets/img/vehicle-compare/chrome-data-logo.png"></a>'
        };
      }
      return {
        txt: 'Toyota has an advantage',
        credit: 'Independent analysis by <a target="_blank" href="http://www.chromedata.com"><img alt="chrome data logo" src="/assets/img/vehicle-compare/chrome-data-logo.png"></a>'
      };
    }
  };
});

